import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import Select from 'components/Input/Select';
import SquareOptions from 'components/Input/SquareOptions';

const SquareSelectOptions = ({ wrapperClassName, name, options, formErrors }) => (
    <SquareOptions
        wrapperClassName={wrapperClassName}
        className="hide-sm"
        name={name}
        options={options}
        small
        formErrors={formErrors}
    >
        <Field component={Select} name={name} options={options} wrapperClassName="hide-lg" />
    </SquareOptions>
);

SquareSelectOptions.displayName = 'SquareSelectOptions';

SquareSelectOptions.propTypes = {
    formErrors: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    ).isRequired,
    wrapperClassName: PropTypes.string,
};

SquareSelectOptions.defaultProps = {
    name: '',
    wrapperClassName: '',
};

/**
 * SquareSelectOptions Functional Component.
 */
export default SquareSelectOptions;
